import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

const demoSteps = [
  { path: '/demo/config', label: 'Configure', step: 1 },
  { path: '/demo/stream', label: 'Stream', step: 2 },
  { path: '/demo/logs', label: 'Logs', step: 3 },
]

export default function Navigation() {
  const location = useLocation()
  const isDemo = location.pathname.startsWith('/demo')

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 mr-6">
          <span className="font-display text-xl font-semibold">
            Zone <span className="text-accent">Ambient</span> SDK
          </span>
        </Link>

        {/* Main Nav */}
        <nav className="flex items-center gap-6 text-sm">
          <Link
            to="/"
            className={cn(
              'transition-colors hover:text-foreground/80',
              location.pathname === '/' ? 'text-foreground' : 'text-foreground/60'
            )}
          >
            Home
          </Link>
          <Link
            to="/demo/config"
            className={cn(
              'transition-colors hover:text-foreground/80',
              isDemo ? 'text-foreground' : 'text-foreground/60'
            )}
          >
            Demo
          </Link>
          <a
            href="/docs"
            className="text-foreground/60 transition-colors hover:text-foreground/80"
          >
            Docs
          </a>
        </nav>

        {/* Demo Steps (shown only in demo pages) */}
        {isDemo && (
          <nav className="ml-auto flex items-center gap-2">
            {demoSteps.map((step) => (
              <Link key={step.path} to={step.path}>
                <Button
                  variant={location.pathname === step.path ? 'default' : 'ghost'}
                  size="sm"
                  className="gap-2"
                >
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs font-medium">
                    {step.step}
                  </span>
                  {step.label}
                </Button>
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  )
}
